<template>
  <div class="container">
    <receipt-details v-if="receipt" :receipt="receipt"/>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    props: {
      id: {},
    },
    data () {
      return {}
    },
    asyncComputed: {
      receipt () {
        return api
          .get(`receipts/${this.id}`)
          .then(({data}) => data)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/receipts/_id.vue